"use client";

import { BuyGenerationsFlow } from "@/components/BuyGenerationsFlow";
import { Suspense } from "react";

export default function BuyGenerationsPage() {
  return (
    <main className="flex min-h-full w-full flex-col">
      <Suspense fallback={<div className="min-h-[55vh]" aria-label="Loading Plan and billing" />}>
        <BuyGenerationsFlow />
      </Suspense>
    </main>
  );
}
